import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as router from '@attain-apps/fe/web/main/lib/router'
import * as rxjs from 'rxjs'

import * as admin from '../../admin'
import * as me from '../../me'

import { Api } from './api'
import * as runs from './runs'
import type { TypeParams } from './types'

/** Shared connector collection behavior for one route-owned zone context. */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  /** Concurrent connector execution state owned by this collection. */
  public readonly runs: runs.Feature

  constructor() {
    const api = ngCore.inject(Api)
    const rawUrl$ = ngCore.inject(router.Router).selectors.rawUrl.asObservable
    const adminZone$ = ngCore.inject(admin.contexts.Feature).selectors
      .zoneContext.asObservable
    const portalZone$ = ngCore.inject(me.Feature).contexts.selectors.zoneContext
      .asObservable
    super({
      api,
      context$: rxjs.combineLatest([rawUrl$, adminZone$, portalZone$]).pipe(
        rxjs.map(([url, adminZone, portalZone]) =>
          url === '/admin' || url.startsWith('/admin/')
            ? adminZone
            : portalZone,
        ),
        rxjs.distinctUntilChanged(
          (a, b) => a?.tenantId === b?.tenantId && a?.zoneId === b?.zoneId,
        ),
      ),
      identify: connector => connector.id,
      name: ec.Name.Predefined.IntegrationConnector,
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory<TypeParams>(collection => ({
            rowConfig: ({ entity: connector }) => ({
              iconsConfigs: [
                {
                  class: 'atn-icon atn-trash atn-red',
                  onClick: () => {
                    collection.plugins.editingPlugin.feature.actions.markForDeletion
                      .from(
                        `IntegrationConnectors.Table.Row-${connector.id}.Trash.Clicked`,
                      )
                      .dispatch({ id: connector.id })
                  },
                },
              ],
              onClick: () => {
                collection.plugins.editingPlugin.feature.actions.edit
                  .from(
                    `IntegrationConnectors.Table.Row-${connector.id}.Clicked`,
                  )
                  .dispatch({ id: connector.id })
              },
            }),
            search: true,
          })),
        ],
      },
    })
    this.runs = new runs.Feature(this, api)
  }
}
